import { FC, Fragment } from 'react';
import { Switch } from 'react-router-dom';
import { PrivateRoute } from '../router/components';
import RouteConstants from '../router/RouteConstants';
import { CampaignPerformancePage } from './CampaignPerformancePage';

export const CampaignPerformanceRouter: FC = () => (
  <Fragment>
    <Switch>
      <PrivateRoute path={RouteConstants.campaignPerformance} component={CampaignPerformancePage} />
    </Switch>
  </Fragment>
);
